if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();



          $.post(`/cart/update.js`, {
          attributes: { vat_status: "VAT Exempt" }
        });

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        var strapSelection = document.querySelector('.custom-strap-selection');
        if (strapSelection) 
        {
          var checkedRadio = strapSelection.querySelector('input[type="radio"]:checked');
          if (checkedRadio) {
            formData.append('properties[one-time-strap]', 'yes');
          }
        }
        config.body = formData;
        var add_product = true;
        var current_product_alarm = this.submitButton.getAttribute("data-alarm") == "true" ? true : false;

         fetch('/cart.js')
        .then((res) => res.json())
        .then((cart) => {
          const fetches = cart.items.map(item =>
            fetch(`/products/${item.handle}.js`).then(res => res.json())
          );



          Promise.all(fetches).then(products => {
            const cartHasAlarm = products.some(p => p.tags.includes('alarm'));
            if(cartHasAlarm && current_product_alarm == true) 
            {
              //  this.handleErrorMessage("You can't add multiple 'alarm' items to the cart.");
              Fancybox.show([
              {
                  src: '#purchase-multiple-alarms-popup',
                  type: "inline"
              }
              ], {
                  animated: true,
                  mainClass: "purchase-multiple-alarms-conformation",
                  showClass: "purchase-multiple-alarms-popup-open",
                  touch: false,
                  dragToClose: false,
                  swipe: false
              });
              this.submitButton.classList.remove('loading');
              this.querySelector('.loading__spinner').classList.add('hidden');
              this.submitButton.removeAttribute('aria-disabled');
              add_product = false;
              return;
            }         
            if(add_product) 
            {
              if (strapSelection && checkedRadio) 
              {
                var radioVariantId = Number(checkedRadio.getAttribute('data-variant-id'));  // Variant ID of the selected strap
                var radioQuantity = 1;  // Static quantity for the custom strap


                var selected_variant = JSON.parse(this.closest('product-info').querySelector('[data-selected-variant]').innerHTML);
                console.log("Selected Variant ID: ", selected_variant);

                // First, add the custom strap to the cart (separate fetch)
                fetch(`${routes.cart_add_url}`, {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                  },
                  body: JSON.stringify({
                    id: radioVariantId,
                    quantity: radioQuantity,
                    properties: {
                      'one-time-strap': "yes",
                      '_strap_img': selected_variant.featured_image ? selected_variant.featured_image.src : '',
                      'Strap Colour': selected_variant.option2 ? selected_variant.option2 : ''
                    }
                  }),
                })
                .then((response) => response.json())
                .then((response) => {
                  if (response.status) {
                    console.log('Custom strap product added to cart:', response);
                  } 
                })
                .catch((e) => {
                  console.error(e);
                })
              }
              setTimeout(() => {
                fetch(`${routes.cart_add_url}`, config)
                .then((response) => response.json())
                .then((response) => {
                  if (response.status) {
                    publish(PUB_SUB_EVENTS.cartError, {
                      source: 'product-form',
                      productVariantId: formData.get('id'),
                      errors: response.errors || response.description,
                      message: response.message,
                    });
                    this.handleErrorMessage(response.description);

                    const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                    if (!soldOutMessage) return;
                    this.submitButton.setAttribute('aria-disabled', true);
                    this.submitButtonText.classList.add('hidden');
                    soldOutMessage.classList.remove('hidden');
                    this.error = true;
                    return;
                  } else if (!this.cart) {
                    window.location = window.routes.cart_url;
                    return;
                  }

                  const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
                  if (!this.error)
                    publish(PUB_SUB_EVENTS.cartUpdate, {
                      source: 'product-form',
                      productVariantId: formData.get('id'),
                      cartData: response,
                    }).then(() => {
                      CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
                    });
                  this.error = false;
                  const quickAddModal = this.closest('quick-add-modal');
                  if (quickAddModal) {
                    document.body.addEventListener(
                      'modalClosed',
                      () => {
                        setTimeout(() => {
                          CartPerformance.measure("add:paint-updated-sections", () => {
                            this.cart.renderContents(response);
                          });
                        });
                      },
                      { once: true }
                    );
                    quickAddModal.hide(true);
                  } else {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  }
                })
                .catch((e) => {
                  console.error(e);
                })
                .finally(() => {
                  this.submitButton.classList.remove('loading');
                  if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
                  if (!this.error) this.submitButton.removeAttribute('aria-disabled');
                  this.querySelector('.loading__spinner').classList.add('hidden');

                  CartPerformance.measureFromEvent("add:user-action", evt);
                });
              }, 800);
            }
          

          });
        });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
